import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Application } from '@softline/application';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-app-grid',
  templateUrl: './app-grid.component.html',
  styleUrls: ['./app-grid.component.css'],
  imports: [UiCoreModule],
})
export class AppGridComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();
  showColor = input(false);
  showMetadata = input(false);

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }
}
